import React from "react"
import styles from "./styles.module.scss"
import Button from "../Button"

const WelcomeModal = (props) => {
  const { toggleModal } = props
  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.modal}>
          <div className={styles.header}>
            <div>恭喜您已成功打开宝箱</div>
            <div>获得幸运值40</div>
          </div>
          <div className={styles.glow}>
            <img
              src="https://fintechapp-prd-1258285289.file.myqcloud.com/static_files/dig-treasure/glow.png"
              alt="glow"
            />
          </div>
          <div className={styles.treasure}>
            <img
              src="https://fintechapp-prd-1258285289.file.myqcloud.com/static_files/dig-treasure/treasure.png"
              alt="treasure"
            />
          </div>
          <div className={styles.btnWrap}>
            <Button title="去看看" size="sm" onClick={toggleModal} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default WelcomeModal
